import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "GreaterThan.svg",
  "use": "GreaterThan.svg-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"GreaterThan.svg\"><path clip-rule=\"evenodd\" d=\"m6.15419 7.69243c.16987-.46713.68626-.70811 1.15339-.53824l11.00002 4.00001c.3556.1293.5924.4673.5924.8458s-.2368.7165-.5924.8458l-11.00002 4c-.46713.1699-.98352-.0711-1.15339-.5382-.16986-.4672.07112-.9835.53825-1.1534l8.67396-3.1542-8.67396-3.15419c-.46713-.16986-.70811-.68625-.53825-1.15338z\" fill=\"#101820\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol